<template>
  <div class="policy-confirmation">
    <div class="coverage">
      <div @click="goBack" class="backDiv" style="margin-left: 5px; margin-right: auto;">
        <i class="pi pi-arrow-left"></i>
        <span> Carrier Information</span>
      </div>
      <div class="coverage-item" v-for="coverage in linesOfCoverage" :key="coverage.coverageType">
        <h3>{{ coverage.line_of_coverage }}</h3>
        <div class="text-group">
          <p v-if="coverage.additionalInsured">Blanket Additional Insured</p>
          <p v-if="coverage.waiverOfSubrogation">Waiver of Subrogation</p>
        </div>
        <div class="text-group">
          <p v-if="coverage.line_of_coverage !== 'Physical Damage'">Limit: ${{ coverage.limit_amount }}</p>
          <p>Deductible: {{ coverage.deductible }}</p>
        </div>
      </div>
    </div>
    <div class="actions">
      <button @click="requestChanges" class="btn btn-request request-changes"><i class="pi pi-pencil"></i> Request Changes</button>
      <button @click="infoIsCorrect" class="btn btn-correct info-correct"><i class="pi pi-check" style="font-weight: bold;"></i> Info is Correct</button>
    </div>
    <p class="note">Please note that this does not initiate any changes to your current active policy.</p>
  </div>
</template>

<script>
export default {
  name: 'PolicyConfirmation',
  data() {
    return {
      linesOfCoverage: []
    };
  },
  mounted() {
    // Retrieve data from localStorage
    const storedData = localStorage.getItem('deruloData');
    if (storedData) {
      const data = JSON.parse(storedData);
     
      this.linesOfCoverage = data.lines_of_coverage || [];
    } else {
      console.error('No data found in localStorage');
    }
  },
  methods: {
    requestChanges() {
      this.$router.push({
      path: '/coveragechanges'
    });
    },
    infoIsCorrect() {
      localStorage.setItem('coverage_changes', 'No Changes Requested');
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      sessionStorage.setItem('scrollToTop', 'true');
      sessionStorage.setItem('previousScrollPosition', scrollPosition);
      this.$router.push({
      path: '/driversinfo'
    });
      
    },
    goBack() {
      // Store the current scroll position
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

      // Set a flag in sessionStorage before navigation
      sessionStorage.setItem('scrollToTop', 'true');
      sessionStorage.setItem('previousScrollPosition', scrollPosition);

      // Navigate back
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>
i {
  margin-right: 5px;
}

.policy-confirmation {
  text-align: center;
  padding: 10px;
}

.header {
  margin-bottom: 20px;
}

.logo {
  max-width: 150px;
}

.steps {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.step {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 5px;
}

.step.completed {
  background-color: green;
}

.step.active {
  background-color: #4CAF50;
}

.coverage {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.coverage-item {
  background-color: #f9f9f9;
  border: 2px solid #ddd;
  border-radius: 7px;
  padding: 0px 20px;
  width: 95%;
  margin: 5px 0;
  text-align: left;
}

.text-group {
  margin: 20px 0px;
}

.text-group p {
  margin: 5px 0px;
}

.change-request {
  font-weight: bold;
}

.change-text {
  width: 90%;
}

.actions {
  text-align: left;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.note {
  font-size: 0.8em;
  color: #888;
}

@media (min-width: 1000px) {
  .policy-confirmation {
    width: 550px !important;
  }
}
</style>
